import { Link } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import type { CreatedTicketMessageProps } from "./TicketIssueModal.types"

export const CreatedTicketMessage = ({ ticket }: CreatedTicketMessageProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "ticketModal" })

  return (
    <span>
      {t("created")}{" "}
      <Link href={ticket.url} target="_blank" type="link">
        {ticket.name}
      </Link>
    </span>
  )
}
